import React from 'react';
import { cx } from '../cx';

// D-09 §15.32 — Start Card
// (.start-card > .start-card-icon + .start-card-label + .start-card-count)
// 작업 진입 카운트 카드. data-group으로 groupTheme(--gt-*) 스코핑 (D-08 §6.4).
export interface StartCardProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode;
  label: React.ReactNode;
  count: React.ReactNode;
  unit?: React.ReactNode;
  /** data-group 스코프값 ('01'~'04' 등) */
  group?: string;
}

export function StartCard({ icon, label, count, unit, group, className = '', ...props }: StartCardProps) {
  return (
    <button
      type="button"
      className={cx('start-card', className)}
      data-group={group}
      {...props}
    >
      <span className="start-card-icon">{icon}</span>
      <span className="start-card-label">{label}</span>
      <span className="start-card-count">
        {count}
        {unit != null && <span className="unit">{unit}</span>}
      </span>
    </button>
  );
}
